import { Component, OnDestroy, OnInit } from "@angular/core";
import { DataService_PanicAlertMaintenance } from "./shared/data.service";
import { PanicAlertSelectListRequest } from "./shared/panic-alert-select-list-request";
import { UserService } from "../../../shared";
import { ConfirmationService } from "primeng/api";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-panic-alert-maintenance",
	templateUrl: "./panic-alert-maintenance.component.html",
	styleUrls: ["./panic-alert-maintenance.component.css"],
})
export class PanicAlertMaintenanceComponent implements OnInit, OnDestroy {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_PanicAlertMaintenance,
		private userService: UserService,
		private confirmationService: ConfirmationService
	) {}
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy(): void {
		try {
			this.subscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
	}

	//////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////

	subscription: any;

	user: any;
	SelectedSchool: any;

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	ActiveOptionID: number = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedPanicAlert: any;
	lstPanicAlert: any = [];

	//Filter lists
	lstCreatedBy: any = [];
	lstSchoolName: any = [];

	TableLoading: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	ToggleText: string = "Deactivate Alert";

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////

	loadPanicAlert() {
		this.errorMessage = "";
		this.TableLoading = true;
		this.onRowUnselect(null);

		var parms: PanicAlertSelectListRequest = {
			SchoolID: this.SelectedSchool.SchoolID,
			StartDate: "",
			EndDate: "",
			Active: this.ActiveOptionID,
		};

		var result = this.dataService.PanicAlertSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstPanicAlert = response;

				//Load Data Filter Lists
				this.lstCreatedBy = Array.from(new Set(this.lstPanicAlert.map((item: any) => item.CreatedBy))).sort();
				this.lstSchoolName = Array.from(new Set(this.lstPanicAlert.map((item: any) => item.SchoolName))).sort();

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadPanicAlert();
	}

	onToggle() {
		this.errorMessage = "";

		if (this.SelectedPanicAlert == undefined) {
			this.errorMessage = "Select an Alert to Deactivate";
			return;
		}

		this.Processing = true;

		var ChangeTo = this.SelectedPanicAlert.Active == true ? 0 : 1;

		var result = this.dataService.PanicAlertToggle(this.SelectedPanicAlert.PortalPanicAlertID, ChangeTo);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "panicalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Alert was " + (ChangeTo == 1 ? "activated" : "deactivated") + " successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.onRefresh();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "panicalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (ChangeTo == 1 ? "Activate" : "Deactivate") + " the Alert: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}
	onDelete() {
		this.errorMessage = "";

		if (this.SelectedPanicAlert == undefined) {
			this.errorMessage = "Select an Alert to Delete";
			return;
		}

		this.confirmationService.confirm({
			key: "panicalertconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"Are you sure you want to delete this Alert? It will NO LONGER SHOW UP IN REPORTS or historical data. If you just want to disable it, you can use the Deactivate button.",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Processing = true;

		var result = this.dataService.PanicAlertDelete(this.SelectedPanicAlert.PortalPanicAlertID);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "panicalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Alert was deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.onRefresh();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "panicalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Delete the Alert: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadPanicAlert();
	}

	onActiveOptionIDChange(val) {
		this.ActiveOptionID = val;

		this.loadPanicAlert();
	}

	onRowSelect(val) {
		this.SelectedPanicAlert = val.data;

		this.ToggleText = "Deactivate Alert";
		if (this.SelectedPanicAlert.EndDTDesc != "Active") {
			this.ToggleText = "Activate Alert";
		}
	}
	onRowUnselect(val) {
		this.SelectedPanicAlert = null;

		this.ToggleText = "Deactivate Alert";
	}

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	IsSU() {
		if (this.user == undefined || this.user.userID == undefined) {
			return false;
		}

		return this.user.userID == 0;
	}

	//////////////////////////////////////////////////////////////////////
}
